import { audioContext } from './audio';

/** Beeps for the three warnings: 20% one beep, 10% two, 5% three, each higher and sharper than the last. */
const BEEPS = [
  { count: 1, freq: 660 },
  { count: 2, freq: 760 },
  { count: 3, freq: 880 },
] as const;
const BEEP_LENGTH = 0.16;
const BEEP_GAP = 0.24;

export function playFuelWarning(level: 1 | 2 | 3): void {
  const ctx = audioContext();
  if (!ctx) return;
  const { count, freq } = BEEPS[level - 1] ?? BEEPS[0];
  const now = ctx.currentTime;
  for (let i = 0; i < count; i++) {
    const start = now + i * BEEP_GAP;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'square';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.08, start + 0.01);
    gain.gain.setValueAtTime(0.08, start + BEEP_LENGTH - 0.02);
    gain.gain.linearRampToValueAtTime(0, start + BEEP_LENGTH);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + BEEP_LENGTH + 0.02);
  }
}
